import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './login';
import Home from './Home';
import Register from './Register';
import UsuariosTable from './Components/UsuariosTable';
import FacturasTable from './Components/FacturasTable';
import TercerosTable from './Components/TercerosTable';
import BancosTable from './Components/BancosTable';
import Dashboard from './Components/Dashboard';
import AddTerceroForm from './Components/AddTerceroForm';
import EditTerceroForm from './Components/EditTerceroForm';
import AddBancoForm from './Components/AddBancoForm';
import EditBancoForm from './Components/EditBancoForm';
import FacturaForm from './Components/FacturaForm';
import EjerciciosTable from './Components/EjerciciosTable';
import InvoiceDetail from './Components/InvoiceDetail';
import TerceroDetail from './Components/TerceroDetail';
import BancoDetail from './Components/BancoDetail';
import UserForm from './Components/UserForm';
import UserDetail from './Components/UserDetail';
import TiposTable from './Components/TiposTable';
import LugaresTable from './Components/LugaresTable';
import ConcesionesTable from './Components/ConcesionesTable';
import LiquidacionesTable from './Components/LiquidacionesTable';
import SepulturasTable from './Components/SepulturasTable';
import MapasTable from './Components/MapasTable';
import PermisosTable from './Components/PermisosTable';
import TitularesTable from './Components/TitularesTable';
import ClausuradosTable from './Components/ClausuradosTable';
import LocalizadoresTable from './Components/LocalizadoresTable';
import EditLugareForm from './Components/EditLugaresForm';
import AddLugarForm from './Components/AddLugareForm';
import LugarDetail from './Components/LugareDetail';
import TasasTable from './Components/TasasTable';
import EditTasaForm from './Components/EditTasaForm';
import AddTasaForm from './Components/AddTasaForm';
import TasaDetail  from './Components/TasaDetail';
import SepulturaDetail from './Components/SepulturaDetail';
import EditSepulturaForm from './Components/EditSepultura';
import AddConcesionForm from './Components/AddConcesioneForm';
import AddTitulareForm from './Components/AddTitulareForm';
import AddClausuradoForm from './Components/AddClausuradoForm';
import EditConcesionForm from './Components/EditConcesioneForm';
import ConcesionDetail from './Components/ConcesioneDetail';
import TitulareDetail from './Components/TitulareDetail';
import ClausuradoDetail from './Components/ClaursuradoDetail';
import EditClausuradoForm from './Components/EditClausurado';
import EditTitulareForm from './Components/EditTitulareForm';
import AddTipoForm from './Components/AddTipoForm';
import EditTipoForm from './Components/EditTipoForm';
import TipoDetail from './Components/TipoDetail';
import TrasladosTable from './Components/TrasladosTable';
import DivisionesTable from './Components/DivisionesTable';
import SubdivisionesTable from './Components/SubdivisionesTable';
import PermisoDetail from './Components/PermisoDetail';
import TrasladoDetail from './Components/TrasladoDetail';
import LiquidacionDetail from './Components/LiquidacioneDetail';
import DivisionDetail from './Components/DivisioneDetail';
import SubdivisionDetail from './Components/SubdivisioneDetail';
import EditPermisoForm from './Components/EditPermiso';
import EditTrasladoForm from './Components/EditTraslado';
import EditLiquidacioneForm from './Components/EditLiquidacione';
import EditDivisioneForm from './Components/EditDivisione';
import EditSubdivisioneForm from './Components/EditSubdivisione';
import AddPermisoForm from './Components/AddPermisoForm';
import AddDivisionForm from './Components/AddDivisioneForm';
import AddSubdivisionForm from './Components/AddSubdivisioneForm';
import AddLiquidacionForm from './Components/AddLiquidacioneForm';
import AddTrasladoForm from './Components/AddTrasladoForm';

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsLoggedIn(true);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');
    if (tokenFromUrl) {
      localStorage.setItem('token', tokenFromUrl);
      setIsLoggedIn(true);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={isLoggedIn ? <Navigate to="/home" /> : <Login setIsLoggedIn={setIsLoggedIn} />} 
        />
        <Route 
          path="/home" 
          element={isLoggedIn ? <Home setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/" />} 
        >
          <Route index element={<Dashboard />} />
          <Route path="usuarios" element={<UsuariosTable />} />
          <Route path="usuarios/add" element={<UserForm />} />
          <Route path="usuarios/edit/:id" element={<UserForm />} />
          <Route path="usuarios/:id" element={<UserDetail />} />
          <Route path="facturas" element={<FacturasTable />} />
          <Route path="facturas/add" element={<FacturaForm />} />
          <Route path="facturas/edit/:id" element={<FacturaForm />} />
          <Route path="terceros" element={<TercerosTable />} />
          <Route path="terceros/add" element={<AddTerceroForm />} />
          <Route path="terceros/edit/:id" element={<EditTerceroForm />} />
          <Route path="terceros/:documento" element={<TerceroDetail />} />
          <Route path="bancos" element={<BancosTable />} />
          <Route path="bancos/add" element={<AddBancoForm />} />
          <Route path="bancos/edit/:id" element={<EditBancoForm />} />
          <Route path="bancos/:codigo" element={<BancoDetail />} />
          <Route path="ejercicios" element={<EjerciciosTable />} />
          <Route path="facturas/view/:id" element={<InvoiceDetail />} />
          <Route path="tipos" element={<TiposTable/>}/>
          <Route path="lugares" element={<LugaresTable/>}/>
          <Route path="concesiones" element={<ConcesionesTable/>}/>
          <Route path="liquidaciones" element={<LiquidacionesTable/>}/>
          <Route path="sepulturas" element={<SepulturasTable/>}/>
          <Route path="mapas" element={<MapasTable/>}/>
          <Route path="permisos" element={<PermisosTable/>}/>
          <Route path="titulares" element={<TitularesTable />} />
          <Route path="clausurados" element={<ClausuradosTable />} />
          <Route path="localizadores" element={<LocalizadoresTable />} />
          <Route path="lugares/edit/:id" element={<EditLugareForm />} />
          <Route path="lugares/add" element={<AddLugarForm />} />
          <Route path="lugares/:id" element={<LugarDetail />} />
          <Route path="tasas" element={<TasasTable />} />
          <Route path="tasas/edit/:id" element={<EditTasaForm />} />
          <Route path="tasas/add" element={<AddTasaForm />} />  
          <Route path="tasas/:id" element={<TasaDetail />} />
          <Route path="sepulturas/:id" element={<SepulturaDetail />} />
          <Route path="sepulturas/edit/:id" element={<EditSepulturaForm />} />
          <Route path="concesiones/add" element={<AddConcesionForm />} /> 
          <Route path="titulares/add" element={<AddTitulareForm />} />
          <Route path="clausurados/add" element={<AddClausuradoForm />} />
          <Route path="concesiones/edit/:id" element={<EditConcesionForm />} />
          <Route path="concesiones/:id" element={<ConcesionDetail />} />  
          <Route path="titulares/:id" element={<TitulareDetail />} />
          <Route path="clausurados/:id" element={<ClausuradoDetail />} /> 
          <Route path="clausurados/edit/:id" element={<EditClausuradoForm />} />
          <Route path="titulares/edit/:id" element={<EditTitulareForm />} />
          <Route path="tipos/add" element={<AddTipoForm />} />
          <Route path="tipos/edit/:id" element={<EditTipoForm />} />
          <Route path="tipos/:id" element={<TipoDetail />} />
          <Route path="traslados" element={<TrasladosTable />} />
          <Route path="divisiones" element={<DivisionesTable />} />
          <Route path="subdivisiones" element={<SubdivisionesTable />} />
          <Route path="permisos/:id" element={<PermisoDetail />} />
          <Route path="traslados/:id" element={<TrasladoDetail />} />
          <Route path="liquidaciones/:id" element={<LiquidacionDetail />} />
          <Route path="divisiones/:id" element={<DivisionDetail />} />
          <Route path="subdivisiones/:id" element={<SubdivisionDetail />} />
          <Route path="permisos/edit/:id" element={<EditPermisoForm />} />
          <Route path="traslados/edit/:id" element={<EditTrasladoForm />} />
          <Route path="liquidaciones/edit/:id" element={<EditLiquidacioneForm />} />
          <Route path="divisiones/edit/:id" element={<EditDivisioneForm />} />
          <Route path="subdivisiones/edit/:id" element={<EditSubdivisioneForm />} />
          <Route path="permisos/add" element={<AddPermisoForm />} />
          <Route path="divisiones/add" element={<AddDivisionForm />} />
          <Route path="subdivisiones/add" element={<AddSubdivisionForm />} />
          <Route path="liquidaciones/add" element={<AddLiquidacionForm />} />
          <Route path="traslados/add" element={<AddTrasladoForm />} />
        
        </Route>
        <Route 
          path="/register" 
          element={isLoggedIn ? <Navigate to="/home" /> : <Register />} 
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}